declare namespace $ {

	type $mol_paragraph__title_shm_agent_message_card_1 = $mol_type_enforce<
		ReturnType< $shm_agent_message_card['role'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_shm_agent_message_card_2 = $mol_type_enforce<
		ReturnType< $shm_agent_message_card['header_extra'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_button_copy__hint_shm_agent_message_card_3 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_button_copy['hint'] >
	>
	type $shm_button_copy__text_shm_agent_message_card_4 = $mol_type_enforce<
		ReturnType< $shm_agent_message_card['text'] >
		,
		ReturnType< $shm_button_copy['text'] >
	>
	type $shm_button_copy__button_sub_shm_agent_message_card_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_button_copy['button_sub'] >
	>
	type $mol_paragraph__title_shm_agent_message_card_6 = $mol_type_enforce<
		ReturnType< $shm_agent_message_card['time'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_shm_agent_message_card_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_agent_message_card_8 = $mol_type_enforce<
		ReturnType< $shm_agent_message_card['content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_agent_message_card extends $mol_card {
		message_theme( ): string
		Role( ): $mol_paragraph
		Header_extra( ): $mol_view
		Copy( ): $shm_button_copy
		Time( ): $mol_paragraph
		Head( ): $mol_view
		Content( ): $mol_view
		role_key( ): string
		role( ): string
		time( ): string
		text( ): string
		header_extra( ): readonly($mol_view)[]
		content( ): readonly($mol_view)[]
		Copy_icon( ): $mol_icon_content_copy
		theme( ): ReturnType< $shm_agent_message_card['message_theme'] >
		attr( ): ({ 
			'role': ReturnType< $shm_agent_message_card['role_key'] >,
		})  & ReturnType< $mol_card['attr'] >
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=card.view.tree.d.ts.map